<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="css">
  /* @import '../node_modules/bootstrap/dist/css/bootstrap.min.css'; */
</style>
